import { render, staticRenderFns } from "./matching-empty-results.vue?vue&type=template&id=640d5e33&"
import script from "./matching-empty-results.vue?vue&type=script&lang=ts&"
export * from "./matching-empty-results.vue?vue&type=script&lang=ts&"
import style0 from "./matching-empty-results.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports